import React from 'react';
import { useQueryParams } from '@/hooks/useQueryParams';
import { getUrls } from '@cliengo/mfe-utils/utils';

const Navbar: React.FC = () => {
  const { returnUrl } = useQueryParams();
  
  const handleGoBack = () => {
    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      window.location.href = getUrls().DASH_URL;
    }
  };
  return (
    <nav className="fixed top-0 left-0 right-0 w-full h-[50px] bg-white border-b border-[#E0E0E0] z-50">
      <div className="h-full flex items-center py-4 px-4">
        <img 
          src="/Iso_Cliengo.png" 
          alt="Cliengo" 
          className="w-7 h-7 object-contain"
        />
        
          <button
            onClick={handleGoBack}
            className="absolute right-0 mr-4 border border-[#ddd] rounded-[18px] py-2 px-2.5 bg-white text-gray-700 hover:bg-gray-50 transition-colors duration-200 font-medium text-sm"
          >
            Volver a la plataforma
          </button>
        
      </div>
    </nav>
  );
};

export default Navbar;